<template lang="pug">
.briq-form-element
  label(for="toggleSwitch") {{ label }}
  briq-tooltip(:help="help")
  .toggle-switch
    label.switch
      input(type="checkbox" :name="name" v-model="innerValue")
      span(class="slider round")
</template>

<script>
export default {
  name: 'BriqToggleSwitch',
  props: {
    value: Boolean,
    label: String,
    name: String,
    help: String,
  },
  data() {
    return { innerValue: this.value }
  },
  watch: {
    innerValue(newVal) {
      this.innerValue = newVal
      this.$emit('input', this.innerValue)
    },
    value(newVal) {
      this.innerValue = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
.toggle-switch
  .switch
    position relative
    display inline-block
    width 38px
    height 20px

  .switch input
    opacity 0
    width 0
    height 0

  .slider
    position absolute
    cursor pointer
    top 0
    left 0
    right 0
    bottom 0
    background-color #D3D3D3
    -webkit-transition 0.4s
    transition 0.4s

    background-image url("/images/checked_white.svg")
    background-position top 6px left 6px
    background-repeat no-repeat

  .slider:before
    position absolute
    content ''
    height 16px
    width 16px
    left 2px
    bottom 2px
    background-color #fff
    -webkit-transition 0.4s
    transition 0.4s

  input:checked + .slider
    background-color: #3e9e00

  input:focus + .slider
    box-shadow 0 0 1px #3e9e00

  input:checked + .slider:before
    -webkit-transform translateX(17px)
    -ms-transform translateX(17px)
    transform translateX(17px)

  /* Rounded sliders */
  .slider.round
    border-radius 28px

  .slider.round:before
    border-radius 50%
</style>
